import { useRoutes } from 'react-router-dom';
import {
  Company,
  Contact,
  CSAE,
  EmergingTechnologies,
  Landing,
  Privacy,
  Products,
  Terms,
} from 'features/misc';
import { publicRoutes } from './public';

export const AppRoutes = () => {
  const commonRoutes = [
    { path: '/', element: <Landing /> },
    { path: '/privacy', element: <Privacy /> },
    { path: '/terms', element: <Terms /> },
    { path: '/csae', element: <CSAE /> },
    { path: '/products', element: <Products /> },
    { path: '/contact', element: <Contact /> },
    { path: '/company', element: <Company /> },
    { path: '/blog/emerging-technologies-in-africa', element: <EmergingTechnologies /> },
  ];
  const routes = publicRoutes;
  const element = useRoutes([...routes, ...commonRoutes]);

  return <>{element}</>;
};
